import styled from 'styled-components';

export const Button = styled.button`
  width: 100%;
  height: 40px;
  margin: 8px 0 0;
  border: 1px solid var(--grey-300);
  border-radius: var(--radius-large);
  background: var(--white);
  color: var(--grey-600);
  font-family: inherit;
  font-size: 14px;
  font-weight: var(--font-weight-semibold);
  line-height: 24px;
  box-shadow: var(--shadow-xs);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  transition: background 0.15s ease, border-color 0.15s ease;

  &:hover {
    background: var(--grey-50);
    box-shadow: var(--shadow-focus);
    color: var(--grey-800);
  }

  &:focus-visible {
    outline: 0;
    box-shadow: var(--shadow-focus);
    border-color: var(--brand-600);
  }
`;
